import React from "react";
import { render } from "react-dom";
import Search from "../widgets/search";
import Cart from "../widgets/cart";

// Search
let searchElem = document.querySelector(".widget-search");
if (searchElem) render(<Search elem={searchElem} />, searchElem);
let smSearchElem = document.querySelector(".sm-widget-search");
if (smSearchElem) render(<Search elem={smSearchElem} sm={true} />, smSearchElem);

// Cart
let cartElem = document.querySelector(".widget-cart");
if (cartElem) render(<Cart elem={cartElem} />, cartElem);
